"use client";

import { VerifiedUser } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";

import { usePasswordReset } from "@/context/passwordReset";
import { useRecaptcha } from "@/context/util/recaptcha";

import StepButtonWrapper from "@/components/wrapper/stepButton";

export default function ResetButton() {
  const { showV2 } = useRecaptcha();
  const {
    errors,
    passwordResetUser,
    setPassword,
    setPasswordAndSecuritySettings,
  } = usePasswordReset();

  function hasErrors() {
    const { answer, id, label, password, passwordConfirmation } = errors;

    const hasEmptyPasswordFields =
      !passwordResetUser?.password?.length ||
      !passwordResetUser?.password?.length;

    const hasAnyEmptyFields =
      hasEmptyPasswordFields ||
      !passwordResetUser?.securityQuestion?.id?.length ||
      !passwordResetUser?.securityQuestion?.label?.length ||
      !passwordResetUser?.securityQuestion?.answer?.length ||
      !passwordResetUser?.securityQuestion?.answerConfirmation?.length;

    const hasPasswordErrors =
      password !== undefined || passwordConfirmation !== undefined;

    const hasAnyErrors =
      answer !== undefined ||
      id !== undefined ||
      label !== undefined ||
      password !== undefined ||
      passwordConfirmation !== undefined;

    if (!passwordResetUser?.token)
      return hasPasswordErrors || hasEmptyPasswordFields;
    else return hasAnyErrors || hasAnyEmptyFields;
  }

  function getTooltip() {
    if (hasErrors()) {
      return "Please complete and validate all fields to reset your account credentials";
    } else if (showV2) {
      return "Please complete the reCAPTCHA to reset your account credentials";
    }
    return "Click to reset your account credentials";
  }

  return (
    <StepButtonWrapper
      button={
        <Tooltip title={getTooltip()}>
          <span>
            <Button
              disabled={hasErrors() || showV2}
              onClick={() =>
                passwordResetUser?.token
                  ? setPasswordAndSecuritySettings(passwordResetUser?.token)
                  : setPassword()
              }
              sx={{
                height: 48,
                padding: "1em 3em",
                width: {
                  xs: "100%",
                  sm: "auto",
                },
              }}
              startIcon={<VerifiedUser />}
              variant="contained"
            >
              Complete
            </Button>
          </span>
        </Tooltip>
      }
      gridSize={{ xs: 12, md: passwordResetUser?.token ? 12 : 8 }}
      containerJustifyContent={passwordResetUser?.token ? "flex-end" : "center"}
    />
  );
}
